









































































































































































import Vue from 'vue';
import axios from 'axios';
import MultiComplete from '@/components/MultiComplete.vue';
import XLSX from 'xlsx';

const BASE_URL = (process.env.NODE_ENV === 'production') ? '/api' : '//localhost:8000';

interface Account {
  code: string;
  name: string;
}

const BASE_YEAR = 2022;
export default Vue.extend({
  name: 'YearOnYearBreakdown',
  components: {MultiComplete},
  data() {
    const today = new Date();
    const thisYear = today.getMonth() < 6 ? today.getFullYear() : today.getFullYear() + 1;
    return {
      breakdownPeriod: 'months' as 'months' | 'weeks',
      depots: [] as string[],
      selectedDepot: 'all',
      year: thisYear,
      yearOptions: [...Array(thisYear - BASE_YEAR + 1).keys()].map((_, i) => BASE_YEAR + i),
      loading: true,
      accounts: {
        new: [],
        lost: [],
        like_for_like: [],
      } as { 'new': Account[], 'lost': Account[], like_for_like: Account[] },
      accountsFilter: {
        new: [],
        lost: [],
        like_for_like: [],
      } as { 'new': Account[], 'lost': Account[], like_for_like: Account[] },
      data: [] as Array<Array<number | string>>,
      breakdownData: [] as Array<Array<number | string>>,
    };
  },
  computed: {
    accountFilter(): string[] {
      return this.accountsFilter.like_for_like
          .concat(this.accountsFilter.new)
          .concat(this.accountsFilter.lost)
          .map((a) => a.code);
    },
  },
  methods: {
    async updateAccounts() {
      const url = `${BASE_URL}/reports/year-on-year/accounts/${this.selectedDepot}/`;
      const response = (await axios.get(url));
      this.accounts = response.data;
    },
    async update() {
      this.loading = true;
      const url = `${BASE_URL}/reports/year-on-year/${this.breakdownPeriod}/${this.selectedDepot}/`;
      const response = (await axios.get(url, {
        params: {
          account: this.accountFilter,
          year: this.year,
        },
      }));
      this.data = response.data.results;
      this.loading = false;
    },
    periodName(period: '1' | '2' | '3' | '4' | '5' | '6' | '7' | '8' | '9' | '10' | '11' | '12' | null): string {
      if (this.breakdownPeriod === 'weeks') {
        return period ?? 'Total';
      } else {
        if (period === null) {
          return 'Total';
        }
        return {
          1: 'January',
          2: 'February',
          3: 'March',
          4: 'April',
          5: 'May',
          6: 'June',
          7: 'July',
          8: 'August',
          9: 'September',
          10: 'October',
          11: 'November',
          12: 'December',
        }[period];
      }
    },
    cellClass(row: string[], i: number): 'loss' | '' {
      if (i % 2 === 0 && parseFloat(row[i]) < parseFloat(row[i + 1])) {
        return 'loss';
      }
      return '';
    },
    download() {
      const wb = XLSX.utils.book_new();
      const selectedPeriodSheet = XLSX.utils.table_to_sheet(this.$refs.table);
      XLSX.utils.book_append_sheet(wb, selectedPeriodSheet, 'Selected Period');
      XLSX.writeFile(wb, `Year-on-Year.xlsx`);
    },
    downloadNewBusiness() {
      const wb = XLSX.utils.book_new();
      const selectedPeriodSheet = XLSX.utils.table_to_sheet(this.$refs.newBusinessTable);
      XLSX.utils.book_append_sheet(wb, selectedPeriodSheet, 'New Business');
      XLSX.writeFile(wb, `NewBusiness.xlsx`);
    },
    downloadLostBusiness() {
      const wb = XLSX.utils.book_new();
      const selectedPeriodSheet = XLSX.utils.table_to_sheet(this.$refs.lostBusinessTable);
      XLSX.utils.book_append_sheet(wb, selectedPeriodSheet, 'Lost Business');
      XLSX.writeFile(wb, `LostBusiness.xlsx`);
    },
    downloadLostLastEightWeeks() {
      const wb = XLSX.utils.book_new();
      const selectedPeriodSheet = XLSX.utils.table_to_sheet(this.$refs.lostLastEightWeeksTable);
      XLSX.utils.book_append_sheet(wb, selectedPeriodSheet, 'Lost Business Last Eight Weeks');
      XLSX.writeFile(wb, `LostBusinessLastEightWeeks.xlsx`);
    },
    async breakdown(column: 4 | 5 | 6, period: number | null) {
      if (period === null) {
        period = 999;
      }
      const url = `${BASE_URL}/reports/year-on-year/new-business/${this.breakdownPeriod}/${period}/${this.selectedDepot}/`;
      const response = await axios.get(url, {
        params: {
          account: this.accountFilter,
          year: this.year,
        },
      });
      this.breakdownData = response.data.results;
      switch (column) {
        case 4:
          (this.$refs.newBusinessBreakdown as HTMLDialogElement).showModal();
          break;
        case 5:
          (this.$refs.lostBusinessBreakdown as HTMLDialogElement).showModal();
          break;
        case 6:
          (this.$refs.lostLastEightWeeksBreakdown as HTMLDialogElement).showModal();
          break;
      }
    },
  },
  watch: {
    async breakdownPeriod() {
      await this.update();
    },
    async selectedDepot() {
      await Promise.all([this.updateAccounts(), this.update()]);
    },
    accountsFilter: {
      deep: true,
      async handler() {
        await this.update();
      },
    },
    year() {
      this.update();
    },
  },
  async mounted() {
    this.depots = (await axios.get<{ depots: string[] }>(`${BASE_URL}/reports/depots/`)).data.depots;
    await Promise.all([this.updateAccounts(), this.update()]);
  },
});
